import { Grid, Typography } from "@mui/material";
import React from "react";
import styled from "styled-components";

const OrderSuccessPage = () => {

  const OrderSuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width:100vw;
  height: 100vh;
  background-color: #f5f5f5;

  img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin-bottom: 1rem;
  }
  
  `
  const MainText = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color:rgb(204, 133, 33);
  font-family:'Ancizar Sans', sans-serif;
  margin-top: -1rem;
  line-height: 1.2;
  `
  const SecondaryText = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  color: #666;
  font-family:'Ancizar Sans', sans-serif;
  margin:unset;
  max-width: 300px;
  text-align: center;
  line-height: 1.1;
  `
  const ReturnHome = styled.a`
  font-size: 0.875rem;
  font-weight: 400;

  font-family:'Ancizar Sans', sans-serif;
  margin:unset;
  max-width: 300px;
  text-align: center;
  line-height: 1.1;
  background-color:rgb(66, 137, 65);
  padding: 0.5rem 1rem;
  margin-top: 1rem;
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
  border-radius: 4px;
  `
  return (
    <OrderSuccessContainer>
      <img
      src={'/temp_images/order-success.png'}
      alt="Order Success"
    />
    <MainText>Order Placed Successfully!</MainText>

    <SecondaryText>Thank you for your order. We have sent Shipping details to your email address.</SecondaryText>

    <ReturnHome href="/" >Return to Home</ReturnHome>

    </OrderSuccessContainer>
   
  );
};

export default OrderSuccessPage;
